module.exports = __webpack_public_path__ + "static/wufan_hot.3521a36c.png";